/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BrandFormData,
    BrandFormDataFromJSON,
    BrandFormDataToJSON,
    BrandFormValidationData,
    BrandFormValidationDataFromJSON,
    BrandFormValidationDataToJSON,
    BrandFormWarningsData,
    BrandFormWarningsDataFromJSON,
    BrandFormWarningsDataToJSON,
} from '../models';

export interface ApiBrandFormCreatePostRequest {
    brandFormData?: BrandFormData;
}

export interface ApiBrandFormDataGetRequest {
    id?: number;
}

export interface ApiBrandFormUpdatePostRequest {
    brandFormData?: BrandFormData;
}

export interface ApiBrandFormValidatePostRequest {
    create?: boolean;
    brandFormData?: BrandFormData;
}

export interface ApiBrandFormWarningsPostRequest {
    brandFormData?: BrandFormData;
}

/**
 * no description
 */
export class BrandFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBrandFormCreatePostRaw(requestParameters: ApiBrandFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BrandForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandFormDataToJSON(requestParameters.brandFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBrandFormCreatePost(requestParameters: ApiBrandFormCreatePostRequest): Promise<void> {
        await this.apiBrandFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiBrandFormDataGetRaw(requestParameters: ApiBrandFormDataGetRequest): Promise<runtime.ApiResponse<BrandFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BrandForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBrandFormDataGet(requestParameters: ApiBrandFormDataGetRequest): Promise<BrandFormData> {
        const response = await this.apiBrandFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBrandFormUpdatePostRaw(requestParameters: ApiBrandFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BrandForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandFormDataToJSON(requestParameters.brandFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBrandFormUpdatePost(requestParameters: ApiBrandFormUpdatePostRequest): Promise<void> {
        await this.apiBrandFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBrandFormValidatePostRaw(requestParameters: ApiBrandFormValidatePostRequest): Promise<runtime.ApiResponse<BrandFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.create !== undefined) {
            queryParameters['create'] = requestParameters.create;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BrandForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandFormDataToJSON(requestParameters.brandFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBrandFormValidatePost(requestParameters: ApiBrandFormValidatePostRequest): Promise<BrandFormValidationData> {
        const response = await this.apiBrandFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBrandFormWarningsPostRaw(requestParameters: ApiBrandFormWarningsPostRequest): Promise<runtime.ApiResponse<BrandFormWarningsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BrandForm/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BrandFormDataToJSON(requestParameters.brandFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BrandFormWarningsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBrandFormWarningsPost(requestParameters: ApiBrandFormWarningsPostRequest): Promise<BrandFormWarningsData> {
        const response = await this.apiBrandFormWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
